// Real overseas teams for transfer offers
export const OVERSEAS_TEAMS = [
  // Premier League
  { name: 'Manchester United', league: 'Premier League', country: 'England' },
  { name: 'Liverpool', league: 'Premier League', country: 'England' },
  { name: 'Arsenal', league: 'Premier League', country: 'England' },
  { name: 'Manchester City', league: 'Premier League', country: 'England' },
  { name: 'Chelsea', league: 'Premier League', country: 'England' },
  { name: 'Tottenham', league: 'Premier League', country: 'England' },
  { name: 'Newcastle United', league: 'Premier League', country: 'England' },
  { name: 'Aston Villa', league: 'Premier League', country: 'England' },
  { name: 'Brighton', league: 'Premier League', country: 'England' },
  { name: 'West Ham', league: 'Premier League', country: 'England' },
  // La Liga
  { name: 'Real Madrid', league: 'La Liga', country: 'Spain' },
  { name: 'Barcelona', league: 'La Liga', country: 'Spain' },
  { name: 'Atletico Madrid', league: 'La Liga', country: 'Spain' },
  { name: 'Real Sociedad', league: 'La Liga', country: 'Spain' },
  { name: 'Villarreal', league: 'La Liga', country: 'Spain' },
  // Bundesliga
  { name: 'Bayern Munich', league: 'Bundesliga', country: 'Germany' },
  { name: 'Borussia Dortmund', league: 'Bundesliga', country: 'Germany' },
  { name: 'RB Leipzig', league: 'Bundesliga', country: 'Germany' },
  { name: 'Bayer Leverkusen', league: 'Bundesliga', country: 'Germany' },
  // Serie A
  { name: 'Inter Milan', league: 'Serie A', country: 'Italy' },
  { name: 'AC Milan', league: 'Serie A', country: 'Italy' },
  { name: 'Juventus', league: 'Serie A', country: 'Italy' },
  { name: 'Napoli', league: 'Serie A', country: 'Italy' },
  { name: 'Roma', league: 'Serie A', country: 'Italy' },
  // Ligue 1
  { name: 'Paris Saint-Germain', league: 'Ligue 1', country: 'France' },
  { name: 'Marseille', league: 'Ligue 1', country: 'France' },
  { name: 'Lyon', league: 'Ligue 1', country: 'France' },
  { name: 'Monaco', league: 'Ligue 1', country: 'France' },
  // Championship
  { name: 'Leeds United', league: 'Championship', country: 'England' },
  { name: 'Sheffield United', league: 'Championship', country: 'England' },
  { name: 'Sunderland', league: 'Championship', country: 'England' },
  { name: 'Norwich City', league: 'Championship', country: 'England' },
  { name: 'Coventry City', league: 'Championship', country: 'England' },
  // Liga MX
  { name: 'Club America', league: 'Liga MX', country: 'Mexico' },
  { name: 'Guadalajara', league: 'Liga MX', country: 'Mexico' },
  { name: 'Monterrey', league: 'Liga MX', country: 'Mexico' },
  { name: 'Tigres UANL', league: 'Liga MX', country: 'Mexico' },
  { name: 'Cruz Azul', league: 'Liga MX', country: 'Mexico' },
  // Chinese Super League
  { name: 'Shanghai Port', league: 'Chinese Super League', country: 'China' },
  { name: 'Shandong Taishan', league: 'Chinese Super League', country: 'China' },
  { name: 'Beijing Guoan', league: 'Chinese Super League', country: 'China' },
  { name: 'Guangzhou FC', league: 'Chinese Super League', country: 'China' },
  // Saudi Pro League
  { name: 'Al Hilal', league: 'Saudi Pro League', country: 'Saudi Arabia' },
  { name: 'Al Nassr', league: 'Saudi Pro League', country: 'Saudi Arabia' },
  { name: 'Al Ahli', league: 'Saudi Pro League', country: 'Saudi Arabia' },
  { name: 'Al Ittihad', league: 'Saudi Pro League', country: 'Saudi Arabia' },
  // MLS
  { name: 'LA Galaxy', league: 'MLS', country: 'USA' },
  { name: 'Inter Miami', league: 'MLS', country: 'USA' },
  { name: 'LAFC', league: 'MLS', country: 'USA' },
  { name: 'Atlanta United', league: 'MLS', country: 'USA' },
  // Eredivisie
  { name: 'Ajax', league: 'Eredivisie', country: 'Netherlands' },
  { name: 'PSV Eindhoven', league: 'Eredivisie', country: 'Netherlands' },
  { name: 'Feyenoord', league: 'Eredivisie', country: 'Netherlands' },
  // Primeira Liga
  { name: 'Benfica', league: 'Primeira Liga', country: 'Portugal' },
  { name: 'Porto', league: 'Primeira Liga', country: 'Portugal' },
  { name: 'Sporting CP', league: 'Primeira Liga', country: 'Portugal' },
  // Brasileirao
  { name: 'Flamengo', league: 'Brasileirao', country: 'Brazil' },
  { name: 'Palmeiras', league: 'Brasileirao', country: 'Brazil' },
  { name: 'Santos', league: 'Brasileirao', country: 'Brazil' },
  // K League
  { name: 'Jeonbuk Hyundai', league: 'K League', country: 'South Korea' },
  { name: 'Ulsan Hyundai', league: 'K League', country: 'South Korea' },
  // A-League
  { name: 'Melbourne Victory', league: 'A-League', country: 'Australia' },
  { name: 'Sydney FC', league: 'A-League', country: 'Australia' },
];

// Calculate player market value (in millions $)
export const calculatePlayerValue = (player) => {
  const { overall, age, potential } = player;
  const baseValue = Math.pow((overall - 50) / 10, 2) * 2;
  const ageFactor = age <= 23 ? 1.5 : age <= 27 ? 1.3 : age <= 30 ? 1.0 : age <= 33 ? 0.6 : 0.3;
  const potentialBonus = (potential - overall) * 0.3;
  const value = Math.max(0.5, (baseValue + potentialBonus) * ageFactor);
  return Math.round(value * 10) / 10;
};

// Format value display
export const formatValue = (value) => {
  if (value >= 100) return `$${Math.round(value)}M`;
  if (value >= 10) return `$${Math.round(value * 10) / 10}M`;
  return `$${Math.round(value * 10) / 10}M`;
};

// Player growth/regression per season
export const applySeasonGrowth = (player) => {
  const { age, overall, potential } = player;
  let newOverall = overall;
  let newAge = age + 1;

  if (age <= 23) {
    // Young players grow toward potential
    const growthRate = Math.random() * 0.6 + 0.2;
    const maxGrowth = Math.min(potential - overall, 5);
    newOverall = Math.min(potential, overall + Math.round(maxGrowth * growthRate));
  } else if (age <= 27) {
    // Peak approaching - small growth
    const growth = Math.random() > 0.4 ? Math.floor(Math.random() * 2) + 1 : 0;
    newOverall = Math.min(potential, overall + growth);
  } else if (age <= 30) {
    // Peak years - stable
    const change = Math.random() > 0.7 ? -1 : Math.random() > 0.8 ? 1 : 0;
    newOverall = Math.max(50, Math.min(99, overall + change));
  } else if (age <= 33) {
    // Declining
    const decline = Math.floor(Math.random() * 3);
    newOverall = Math.max(50, overall - decline);
  } else {
    // Sharp decline
    const decline = Math.floor(Math.random() * 4) + 1;
    newOverall = Math.max(45, overall - decline);
  }

  return {
    ...player,
    age: newAge,
    overall: newOverall,
    stats: { goals: 0, assists: 0, yellowCards: 0, redCards: 0, matchesPlayed: 0, cleanSheets: 0 }
  };
};

// Generate random transfer offer from overseas
export const generateTransferOffer = (player, teamName) => {
  const overseasTeam = OVERSEAS_TEAMS[Math.floor(Math.random() * OVERSEAS_TEAMS.length)];
  const baseValue = calculatePlayerValue(player);
  const offerMultiplier = 0.8 + Math.random() * 0.6;
  const offerAmount = Math.round(baseValue * offerMultiplier * 10) / 10;

  return {
    id: `offer-${Date.now()}-${Math.random().toString(36).substr(2, 5)}`,
    player,
    fromTeam: overseasTeam,
    toTeam: teamName,
    amount: offerAmount,
    status: 'pending',
    type: 'incoming'
  };
};
